export default __webpack_public_path__ + "static/media/icono4.56752a72.svg";